/**
 * @generated SignedSource<<a7f64f77151748ea00ae830a62cb9368>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DependentAddQuery$variables = Record<PropertyKey, never>;
export type DependentAddQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DependentAdd_query">;
};
export type DependentAddQuery = {
  response: DependentAddQuery$data;
  variables: DependentAddQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DependentAddQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DependentAdd_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DependentAddQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LabelValue",
        "kind": "LinkedField",
        "name": "availableDependentRelationships",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyRequiredDocsDependentKind",
            "kind": "LinkedField",
            "name": "requiredDocsDependents",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dependentKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyRequiredDocs",
                "kind": "LinkedField",
                "name": "requiredDocs",
                "plural": true,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b21da49c443e01805c269cc9adfce18",
    "id": null,
    "metadata": {},
    "name": "DependentAddQuery",
    "operationKind": "query",
    "text": "query DependentAddQuery {\n  ...DependentAdd_query\n}\n\nfragment DependentAdd_query on Query {\n  ...DependentFormCard_query\n}\n\nfragment DependentFormCard_query on Query {\n  availableDependentRelationships {\n    label\n    value\n  }\n  companyDomainName {\n    requiredDocsDependents {\n      dependentKind\n      requiredDocs {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ed5d015f8302e5712ea4022b0ecfd44";

export default node;
